import ActionType from '@actions/type';
import { INTRO_STEP } from '@consts/app';
import LocalStorage from '@core/local-storage';
import { combineReducers } from 'redux';

function newUserIntro(state = INTRO_STEP.OVER, action) {
  switch (action.type) {
    case ActionType.HOTELS_SAVE_SUCCESS:
      return state < INTRO_STEP.HOTEL_SAVED ? INTRO_STEP.HOTEL_SAVED : state;
    case ActionType.ROOMTYPES_SAVE_SUCCESS:
      return state < INTRO_STEP.ROOMTYPE_SAVED ? INTRO_STEP.ROOMTYPE_SAVED : state;
    case ActionType.INTRO_SET_STEP:
      return action.step;
    case ActionType.LOGIN_SUCCESS:
      // 根据门店数量判断是否显示新用户引导
      if (action.data && action.data.innCount === 0 && action.data.roleId === 2) {
        return INTRO_STEP.SHOW_HOTEL_FORM;
      }
      return INTRO_STEP.OVER;
    default:
      return state;
  }
}

const otaHomeIntroStep = +LocalStorage.getItem('otaHomeIntroStep') || 1;
function otaHomeIntro(state = otaHomeIntroStep, action) {
  switch (action.type) {
    case ActionType.OTA_HOME_INTRO_SET_STEP:
      LocalStorage.setItem('otaHomeIntroStep', action.step);
      return action.step;
    case ActionType.JUMP_TO: {
      let step = LocalStorage.getItem('otaHomeIntroStep');
      if (!step) {
        LocalStorage.setItem('otaHomeIntroStep', 1);
        step = 1;
      }
      return +step;
    }
    default:
      return state;
  }
}

const otaTodayIntroStep = +LocalStorage.getItem('otaTodayIntroStep') || 1;
function otaTodayIntro(state = otaTodayIntroStep, action) {
  switch (action.type) {
    case ActionType.OTA_TODAY_INTRO_SET_STEP:
      LocalStorage.setItem('otaTodayIntroStep', action.step);
      return action.step;
    case ActionType.JUMP_TO: {
      let step = LocalStorage.getItem('otaTodayIntroStep');
      if (!step) {
        LocalStorage.setItem('otaTodayIntroStep', 1);
        step = 1;
      }
      return +step;
    }
    default:
      return state;
  }
}

export default combineReducers({
  newUserIntro,
  otaHomeIntro,
  otaTodayIntro,
});



// WEBPACK FOOTER //
// ./reducers/app/intro.js